<template>
  <div id="app">
    <div class="header">
      <div class="logo">
        <a href="/">
          <img src="/assets/images/clr.png" style="width:375px; height:100px;" />
        </a>
      </div>

      <TheMainNavigation />
    </div>

    <div class="container wrap_top">
    </div>

    <div class="container wrap_middle clearfix">
      <router-view/>
    </div>

    <div class="wrap_bottom" style="clear:both;">
      <TheFooter />
    </div>
  </div>
</template>

<script>
import TheMainNavigation from '@/components/TheMainNavigation.vue';
import TheFooter from '@/components/TheFooter.vue';

export default {
  name: 'App',

  components: {
    TheMainNavigation,
    TheFooter,
  },
};
</script>

<style>
</style>
